import { render, staticRenderFns } from "./LiveStatsAnalysis.vue?vue&type=template&id=4537ba7d&"
import script from "./LiveStatsAnalysis.vue?vue&type=script&lang=js&"
export * from "./LiveStatsAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./LiveStatsAnalysis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports